import { PaginatedList } from '@/data/hubspot/types/common';
import { PaymentData, PaymentRequestBody } from '@/data/hubspot/types/payments';
import { useHubspotCustomerKy } from '@/data/hubspot/useHubSpotKy';
import { shouldMock } from '@/lib/utils';
import { useQuery } from '@tanstack/react-query';
import { paymentSampleData } from '../../sample/payments';

const DEFAULT_OPTIONS: PaymentRequestBody = {
  sort_by: 'DESC',
  sort_col: 'PAYMENT_DATE',
  size: 10,
  page: 1,
};

export function usePayments(options: Partial<PaymentRequestBody>) {
  const ky = useHubspotCustomerKy();

  const pageBody = { ...DEFAULT_OPTIONS, ...options };

  return useQuery({
    queryKey: ['payments', pageBody],
    queryFn: async () => {
      if (shouldMock) {
        return paymentSampleData as unknown as PaginatedList<PaymentData>;
      }
      return await ky
        .get('payments', {
          searchParams: pageBody,
        })
        .json<PaginatedList<PaymentData>>();
    },
  });
}
